import PropTypes from "prop-types";

import { ExamQuestionsContext } from "./examQuestionsContext";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useGetQuestionsQuery } from "../../../../../redux/apis/examApi";

export const ExamQuestionsContextProvider = ({ children }) => {
  const [exams, setExams] = useState();
  const [chapter, setChapter] = useState();
  const [selectedChapter, setSelectedChapter] = useState([]);
  const [chosenChapter, setChosenChapter] = useState([]);
  const [dbType, setDbType] = useState();
  const [selectedDbType, setSelectedDbType] = useState([]);
  const [selectedUni, setSelectedUni] = useState([]);
  const [shift, setShift] = useState();
  const [selectedShift, setSelectedShift] = useState([]);
  const [chosenShift, setChosenShift] = useState([]);
  const [subject, setSubject] = useState();
  const [selectedSubject, setSelectedSubject] = useState([]);
  const [chosenSubject, setChosenSubject] = useState([]);
  const [topic, setTopic] = useState();
  const [selectedTopic, setSelectedTopic] = useState([]);
  const [chosenTopic, setChosenTopic] = useState([]);
  const [unit, setUnit] = useState();
  const [selectedUnit, setSelectedUnit] = useState([]);
  const [chosenUnit, setChosenUnit] = useState([]);
  const [university, setUniversity] = useState();
  const [chosenUni, setChosenUni] = useState([]);
  const [year, setYear] = useState();
  const [chosenYear, setChosenYear] = useState([]);
  const [selectedYear, setSelectedYear] = useState([]);
  const [commonValues, setCommonValues] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [questions, setQuestions] = useState([]);

  // for single question editing section
  const [getSubject, setGetSubject] = useState([]);
  const [getChapter, setGetChapter] = useState([]);
  const [getTopic, setGetTopic] = useState([]);
  const [rotate, setRotate] = useState("");

  const apiUrl = import.meta.env.VITE_APP_API;
  const access_token = JSON.parse(localStorage.getItem("faceAuthTokenData"))
    .token.access;

  useEffect(() => {
    async function GetAllFilters() {
      const result = await axios.get(`${apiUrl}/api/exam/get_all_filters`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log(result);
      setExams(result.data);
      setChapter(result.data.chapter);
      setDbType(result.data.database_type);
      setUniversity(result.data.university);
      setYear(result.data.year);
      setSubject(result.data.subject);
      setUnit(result.data.unit);
      setShift(result.data.shift);
      setTopic(result.data.topic);
    }

    GetAllFilters();
  }, [access_token, apiUrl]);

  const divFilterRef = useRef(null);

  const handleClickOutside = (event) => {
    if (divFilterRef.current && !divFilterRef.current.contains(event.target)) {
      setRotate("");
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const {
    data: questionsData,
    isError: isErrorQuestions,
    isSuccess: isSuccessQuestions,
    isLoading: isLoadingQuestions,
    refetch: refetchQuestions,
  } = useGetQuestionsQuery({
    database: `${[...selectedDbType].join(",")}`,
    university: `${chosenUni.join(",")}`,
    years: `${chosenYear.join(",")}`,
    unit: `${chosenUnit.join(",")}`,
    shift: `${chosenShift.join(",")}`,
    subject: `${chosenSubject.join(",")}`,
    chapter: `${chosenChapter.join(",")}`,
    topic: `${chosenTopic.join(",")}`,
    page: `${currentPage}`,
  });

  useEffect(() => {
    if (isSuccessQuestions && questionsData) {
      setQuestions(questionsData);
    }
  }, [isSuccessQuestions, questionsData]);

  useEffect(() => {
    refetchQuestions();
  }, [
    refetchQuestions,
    selectedDbType,
    chosenUni,
    chosenYear,
    chosenUnit,
    chosenShift,
    chosenChapter,
    chosenTopic,
    currentPage,
  ]);

  return (
    <ExamQuestionsContext.Provider
      value={{
        exams,
        setExams,
        chapter,
        setChapter,
        selectedChapter,
        setSelectedChapter,
        chosenChapter,
        setChosenChapter,
        dbType,
        setDbType,
        selectedDbType,
        setSelectedDbType,
        shift,
        setShift,
        selectedShift,
        setSelectedShift,
        chosenShift,
        setChosenShift,
        subject,
        setSubject,
        selectedSubject,
        setSelectedSubject,
        chosenSubject,
        setChosenSubject,
        topic,
        setTopic,
        selectedTopic,
        setSelectedTopic,
        unit,
        setUnit,
        selectedUnit,
        chosenUnit,
        setChosenUnit,
        setSelectedUnit,
        university,
        setUniversity,
        chosenUni,
        setChosenUni,
        year,
        setYear,
        selectedYear,
        setSelectedYear,
        commonValues,
        setCommonValues,
        selectedUni,
        setSelectedUni,
        chosenYear,
        setChosenYear,
        setCurrentPage,
        chosenTopic,
        setChosenTopic,
        questions,
        setQuestions,
        rotate,
        setRotate,
        getSubject,
        setGetSubject,
        getChapter,
        setGetChapter,
        getTopic,
        setGetTopic,
        divFilterRef,
        handleClickOutside,
      }}
    >
      {children}
    </ExamQuestionsContext.Provider>
  );
};

ExamQuestionsContextProvider.propTypes = {
  children: PropTypes.any,
};
